<template>
  <div class="bookingform-list">
    <h2>Booking Form List</h2>
    <div class="d-flex w-100 justify-content-md-end justify-content-center">
      <search-box class="col-md-3 col-12" v-model="search"></search-box>
    </div>
    <v-client-table
      :data="filteredBookingForms"
      :columns="columns"
      :options="options"
      @row-click="showBookingForm"
    ></v-client-table>
  </div>
</template>

<script>
import SearchBox from "@/components/tools/SearchBox.vue";
const api = window.api;
import moment from 'moment';

export default {
  name: "BookingForms",
  components: {
    SearchBox,
  },
  data() {
    return {
      bookingforms: [],
      search: "",
      columns: ["id", "ModifiedUTC", "CreatedUTC", "RefCode", "PaxName", "Email", "SecondaryRefCode"],
      options: {
        headings: {
          RefCode: "Ref original",
          SecondaryRefCode: "Ref Secundario",
          FirstName: "First Name",
          LastName: "Last Name",
          CreatedUTC: "Fecha",
          ModifiedUTC: "Última Modificación",
        },
        sortable: ["id", "ModifiedUTC", "CreatedUTC", "RefCode", "PaxName", "Email", "SecondaryRefCode"],
        filterable: ["id", "ModifiedUTC", "CreatedUTC", "RefCode", "PaxName", "Email", "SecondaryRefCode"],
        perPage: 10,
        perPageValues: [10, 20, 50],
        skin: "table table-striped table-hover",
        templates: {
          CreatedUTC: (h, row) => {
            return moment.utc(row.CreatedUTC).local().format('DD/MM/YYYY HH:mm');
          },
          ModifiedUTC: (h, row) => {
            return moment.utc(row.ModifiedUTC).local().format('DD/MM/YYYY HH:mm');
          }
        }
      },
    };
  },
  computed: {
    filteredBookingForms() {
      if (!this.bookingforms || !Array.isArray(this.bookingforms)) {
        return [];
      }
      if (!this.search) return this.bookingforms;
      const searchLower = this.search?.toLowerCase();
      return this.bookingforms.filter((form) => {
        return (
          form.id?.toString().includes(searchLower) ||
          form.ModifiedUTC?.toString().includes(searchLower) ||
          form.CreatedUTC?.toString().includes(searchLower) ||
          form.RefCode?.toLowerCase().includes(searchLower) ||
          form.PaxName?.toLowerCase().includes(searchLower) ||
          form.Email?.toLowerCase().includes(searchLower) ||
          form.SecondaryRefCode?.toLowerCase().includes(searchLower)
        );
      });
    },
  },
  mounted() {
    this.fetchBookingForms();
  },
  methods: {
    async fetchBookingForms() {
      this.bookingforms = await api.get("/api/bookingform/?orderBy=id");
    },
    showBookingForm(data) {
      this.$router.push({ name: "bookingform", params: { id: data.row.id } });
    },
  },
};
</script>

<style scoped>
.bookingform-list {
  margin: 20px;
}
.mb-4 {
  margin-bottom: 16px;
}
</style>
